<template>
  <div class="container text-left">
    <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
    <div class="row">
      <div class="col-lg-12">
        <BreadcrumbsHelper class="sn-bread" :Breadcrumbs="this.Breadcrumbs" />
      </div>
    </div>
    <div class="tab-container col-lg-12">
      <h1 v-if="!location.name" class="title">Untitled</h1>
      <h1 v-else class="title">{{ location.name }}</h1>
      <b-card no-body>
        <div class="line"></div>
        <b-form v-on:submit.prevent v-on:submit.exact="onSubmit">
          <b-tabs pills justified card v-model="tabIndex" content-class="mt-1">
            <div class="content">
              <b-tab class="tab-text" active>
                <template slot="title">
                  <div class="tab-class">1</div>
                  <div class="tab-title type-class">Location</div>
                </template>
                <div class="row">
                  <div class="col-lg-6">
                    <h1>Location</h1>
                    <b-form-group label="Google Place (Search for an existing Google Place or address)" label-for="name">
                      <gmap-autocomplete
                        @place_changed="setPlace"
                        :value="location.googlePlaceName"
                        :selectFirstOnEnter="true"
                        class="form-control"
                        style="width: 100%"
                        :state="submitted && $v.location.coords.lat.$error ? false : null"
                      />
                      <b-form-invalid-feedback class="d-block red" v-if="submitTest && !$v.location.coords.lat.required">
                        <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />You need to use this to at least choose
                        an address. This is what sets the map correctly on the travel site.
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <span class="small">If your location doesn't have an existing google place please enter your location name below</span>
                    <b-form-group label="Name *" label-for="name">
                      <b-form-input id="name" name="name" v-model="location.name" @change="generateSlug()" v-validate="{ required: true }" :state="validateState(location.name)" />
                      <span class="red"
                        ><font-awesome-icon v-if="veeErrors.first('name')" icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />{{
                          veeErrors.first('name')
                        }}</span
                      >
                    </b-form-group>
                    <b-form-group label="Slug" label-for="slug" v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor'">
                      <b-form-input id="slug" name="slug" ref="slug" v-model="location.slug" v-validate="{ required: true }" :state="validateState('location.slug')" />
                      <span class="red"
                        ><font-awesome-icon v-if="veeErrors.first('slug')" icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />{{
                          veeErrors.first('slug')
                        }}</span
                      >
                    </b-form-group>
                    <b-form-group label="Organization *" label-for="org">
                      <b-form-select
                        id="org"
                        name="organization"
                        v-model="location.organization_id"
                        v-validate="{ required: true }"
                        :state="validateState('location.organization_id')"
                      >
                        <option value="">Select Organization</option>
                        <option v-for="(org, index) in userOrgs" :value="org.value" :key="index">{{ org.text }}</option>
                      </b-form-select>
                      <span class="red"
                        ><font-awesome-icon
                          v-if="veeErrors.first('organization')"
                          icon="exclamation-circle"
                          size="1x"
                          style="color: red"
                          class="mr-1 fas fa-exclamation-circle"
                        />{{ veeErrors.first('organization') }}</span
                      >
                    </b-form-group>
                    <b-form-group label="Location Type *" label-for="type">
                      <b-form-select
                        id="type"
                        name="type"
                        v-model="location.category"
                        :ref="location.category"
                        @change="typeSelected(location.category)"
                        v-validate="{ required: true }"
                        :state="validateState('location.category')"
                      >
                        <option value="accommodation">Accommodation</option>
                        <option value="attraction">Attraction</option>
                        <option value="food">Food & Beverage Service</option>
                        <option value="retail">Retail</option>
                        <option value="service">Service</option>
                        <option value="shoppingDestination">Shopping Destination</option>
                        <option value="venue">Venue</option>
                        <option value="informationSource">Information Source</option>
                      </b-form-select>
                      <span class="red"
                        ><font-awesome-icon v-if="veeErrors.first('type')" icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />{{
                          veeErrors.first('type')
                        }}</span
                      >
                    </b-form-group>
                  </div>

                  <div class="col-lg-6">
                    <div v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor'" class="availability-section">
                      <h1>Availability</h1>
                      <b-form-group label="Publish" label-for="publish">
                        <b-form-radio-group id="publish" v-model="location.publish">
                          <b-form-radio value="None"><b>None</b><br />Is not displayed anywhere</b-form-radio>
                          <b-form-radio value="Limited"
                            ><b>Limited</b><br />
                            Only on the website</b-form-radio
                          >
                          <b-form-radio value="Everywhere"
                            ><b>Everywhere</b><br />
                            Available on the website &amp; apps</b-form-radio
                          >
                          <b-form-radio value="Everywhere + Featured"
                            ><b>Everywhere &amp; Featured</b><br />
                            Available on the website &amp; apps. Also used as featured content.</b-form-radio
                          >
                        </b-form-radio-group>
                      </b-form-group>
                    </div>
                    <div v-else class="mt-5"></div>
                  </div>
                </div>
              </b-tab>
              <b-tab :disabled="!location.name || !location.slug || !location.organization_id || !location.category" class="tab-text">
                <template slot="title">
                  <div class="tab-class">2</div>
                  <div class="tab-title type-class">Contact Details</div>
                </template>
                <div class="contact-info-section">
                  <h1>Contact Details</h1>
                  <b-form-group label="Address *" label-for="address">
                    <b-form-input id="address" name="address" v-model="location.address" v-validate="{ required: true }" :state="validateState('location.address')" />
                    <span class="red"
                      ><font-awesome-icon v-if="veeErrors.first('address')" icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />{{
                        veeErrors.first('address')
                      }}</span
                    >
                  </b-form-group>

                  <b-form-group label="City *" label-for="city">
                    <b-form-input id="city" name="city" v-model="location.city" v-validate="{ required: true }" :state="validateState('location.city')" />
                    <span class="red"
                      ><font-awesome-icon v-if="veeErrors.first('city')" icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />{{
                        veeErrors.first('city')
                      }}</span
                    >
                  </b-form-group>

                  <b-form-group label="Zip Code *" label-for="zip">
                    <b-form-input id="zip" name="zip" v-model="location.zip" v-validate="{ required: true }" :state="validateState('location.zip')" />
                    <span class="red"
                      ><font-awesome-icon v-if="veeErrors.first('zip')" icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />{{
                        veeErrors.first('zip')
                      }}</span
                    >
                  </b-form-group>

                  <b-form-group label="Directions" label-for="directions" class="text-left contentField">
                    <froala id="directions" :tag="'textarea'" :config="config" v-model="location.directions" @input="dirty = true" />
                    <div class="text-right">150 words</div>
                  </b-form-group>

                  <TelephoneInput label="Phone Number" name="venuePhone" v-model="location.telephone" :v="$v.location.telephone" />

                  <b-form-group label="Counties *" label-for="counties">
                    <b-form-select
                      id="counties"
                      name="counties"
                      ref="counties"
                      multiple
                      v-model="location.counties"
                      @input="dirty = true"
                      v-validate="{ required: true }"
                      :state="validateState('location.counties')"
                    >
                      <option value="Autauga">Autauga</option>
                      <option value="Baldwin">Baldwin</option>
                      <option value="Barbour">Barbour</option>
                      <option value="Bibb">Bibb</option>
                      <option value="Blount">Blount</option>
                      <option value="Bullock">Bullock</option>
                      <option value="Butler">Butler</option>
                      <option value="Calhoun">Calhoun</option>
                      <option value="Chambers">Chambers</option>
                      <option value="Cherokee">Cherokee</option>
                      <option value="Chilton">Chilton</option>
                      <option value="Choctaw">Choctaw</option>
                      <option value="Clarke">Clarke</option>
                      <option value="Clay">Clay</option>
                      <option value="Cleburne">Cleburne</option>
                      <option value="Coffee">Coffee</option>
                      <option value="Colbert">Colbert</option>
                      <option value="Conecuh">Conecuh</option>
                      <option value="Coosa">Coosa</option>
                      <option value="Covington">Covington</option>
                      <option value="Crenshaw">Crenshaw</option>
                      <option value="Cullman">Cullman</option>
                      <option value="Dale">Dale</option>
                      <option value="Dallas">Dallas</option>
                      <option value="DeKalb">DeKalb</option>
                      <option value="Elmore">Elmore</option>
                      <option value="Escambia">Escambia</option>
                      <option value="Etowah">Etowah</option>
                      <option value="Fayette">Fayette</option>
                      <option value="Franklin">Franklin</option>
                      <option value="Geneva">Geneva</option>
                      <option value="Greene">Greene</option>
                      <option value="Hale">Hale</option>
                      <option value="Henry">Henry</option>
                      <option value="Houston">Houston</option>
                      <option value="Jackson">Jackson</option>
                      <option value="Jefferson">Jefferson</option>
                      <option value="Lamar">Lamar</option>
                      <option value="Lauderdale">Lauderdale</option>
                      <option value="Lawrence">Lawrence</option>
                      <option value="Lee">Lee</option>
                      <option value="Limestone">Limestone</option>
                      <option value="Lowndes">Lowndes</option>
                      <option value="Macon">Macon</option>
                      <option value="Madison">Madison</option>
                      <option value="Marengo">Marengo</option>
                      <option value="Marion">Marion</option>
                      <option value="Marshall">Marshall</option>
                      <option value="Mobile">Mobile</option>
                      <option value="Monroe">Monroe</option>
                      <option value="Montgomery">Montgomery</option>
                      <option value="Morgan">Morgan</option>
                      <option value="Perry">Perry</option>
                      <option value="Pickens">Pickens</option>
                      <option value="Pike">Pike</option>
                      <option value="Randolph">Randolph</option>
                      <option value="Russell">Russell</option>
                      <option value="St. Clair">St. Clair</option>
                      <option value="Shelby">Shelby</option>
                      <option value="Sumter">Sumter</option>
                      <option value="Talladega">Talladega</option>
                      <option value="Tallapoosa">Tallapoosa</option>
                      <option value="Tuscaloosa">Tuscaloosa</option>
                      <option value="Walker">Walker</option>
                      <option value="Washington">Washington</option>
                      <option value="Wilcox">Wilcox</option>
                      <option value="Winston">Winston</option>
                    </b-form-select>
                    <span class="red"
                      ><font-awesome-icon v-if="veeErrors.first('counties')" icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />{{
                        veeErrors.first('counties')
                      }}</span
                    >
                  </b-form-group>

                  <b-form-group label="Wheelchair Accessible" label-for="wheelchair">
                    <b-form-checkbox switch id="wheelchair" name="wheelchair" v-model="location.wheelchair" />
                  </b-form-group>

                  <b-form-group label="Website" label-for="website">
                    <b-form-input id="website" name="website" v-model="location.website" />
                    <b-form-invalid-feedback class="d-block red" v-if="this.location.website && !urlTest.test(this.location.website)"
                      >Must include http:// or https://</b-form-invalid-feedback
                    >
                  </b-form-group>
                  <div class="map-section">
                    <gmap-map :center="map.center" :zoom="map.zoom" style="width: 100%; height: 400px">
                      <gmap-marker :position="location.coords" @click="map.center = location.coords" />
                    </gmap-map>
                    <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.location.coords.lat.required"
                      >You need to set a marker for the location</b-form-invalid-feedback
                    >
                  </div>
                </div>
              </b-tab>
              <b-tab
                :disabled="
                  !location.name ||
                  !location.slug ||
                  !location.organization_id ||
                  !location.category ||
                  !location.address ||
                  !location.city ||
                  !this.location.counties.length > 0 ||
                  !location.zip
                "
                class="tab-text"
              >
                <template slot="title">
                  <div class="tab-class">3</div>
                  <div class="tab-title type-class">Description</div>
                </template>
                <div class="">
                  <h1>Description</h1>
                  <b-form-group label="Summary Description *" label-for="summary">
                    The "Summary" is a 25 to 40 word overview of your location that may appear in search results and serve as a visitor's first impression of your business.
                    <b-form-textarea
                      id="summary"
                      name="summary"
                      v-model="location.summary"
                      rows="3"
                      max-rows="3"
                      v-validate="{ required: true }"
                      :state="validateState('location.summary')"
                    />
                    <div class="text-right">40 words</div>
                    <span class="red"
                      ><font-awesome-icon v-if="veeErrors.first('summary')" icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />{{
                        veeErrors.first('summary')
                      }}</span
                    >
                  </b-form-group>
                  <b-form-group label="Location Description *" label-for="description" class="text-left contentField">
                    The "Description" is a longer, 150 word paragraph that includes specific details and unique features of your location, such as what visitors can see or do.
                    <froala
                      id="description"
                      name="description"
                      :tag="'textarea'"
                      :config="config"
                      v-model="location.description"
                      @input="dirty = true"
                      v-validate="{ required: true }"
                      :state="validateState('location.description')"
                    />
                    <div class="text-right">150 words</div>
                    <span class="red"
                      ><font-awesome-icon v-if="veeErrors.first('description')" icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />{{
                        veeErrors.first('description')
                      }}</span
                    >
                  </b-form-group>
                  <b-form-group label="Health Precautions" label-for="precautions" class="text-left contentField">
                    <froala id="precautions" :tag="'textarea'" :config="config" v-model="location.precautions" @input="dirty = true" />
                    <div class="text-right">150 words</div>
                  </b-form-group>
                  <div class="experiences-section">
                    <h1>Experiences *</h1>
                    <b-form-group>
                      <b-checkbox-group id="experiences" name="experiences" v-model="location.experiences_ids" v-validate="{ required: true }" @input="dirty = true" buttons>
                        <b-checkbox :value="4" class="rounded-pill">Arts &amp; Culture</b-checkbox>
                        <b-checkbox :value="2" class="rounded-pill">Beaches</b-checkbox>
                        <b-checkbox :value="5" class="rounded-pill">Civil Rights</b-checkbox>
                        <b-checkbox :value="3" class="rounded-pill">Food &amp; Drink</b-checkbox>
                        <b-checkbox :value="1" class="rounded-pill">History</b-checkbox>
                        <b-checkbox :value="6" class="rounded-pill">Music</b-checkbox>
                        <b-checkbox :value="8" class="rounded-pill">Outdoors</b-checkbox>
                        <b-checkbox :value="9" class="rounded-pill">Science &amp; Discovery</b-checkbox>
                        <b-checkbox :value="10" class="rounded-pill">Sports</b-checkbox>
                        <b-checkbox :value="7" class="rounded-pill">Year Round Golf</b-checkbox>
                      </b-checkbox-group>
                      <div class="red">
                        <font-awesome-icon v-if="veeErrors.first('experiences')" icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />{{
                          veeErrors.first('experiences')
                        }}
                      </div>
                    </b-form-group>
                  </div>
                  <div class="badges-section" v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor'">
                    <h1>Badges</h1>
                    <b-form-group v-if="badgeOptions">
                      <b-form-checkbox-group id="badges" name="badges" class="badge-wrap" v-model="location.badges" @input="dirty = true" buttons>
                          <b-form-checkbox  v-for="badge in badgeOptions" :value="badge.value" v-bind:key="badge.value" class="text-center"
                            ><img :alt="badge.text" :src="badge.imageUrl" class="badge-img" />{{ badge.text }}</b-form-checkbox
                          >
                      </b-form-checkbox-group>
                    </b-form-group>
                  </div>
                  <h1 v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor'">Alabama Makers</h1>
                  <div class="row" v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor'">
                    <div class="col-lg-4">
                      <b-form-group label="Alabama Maker" label-for="maker">
                        <b-form-checkbox switch id="maker" name="maker" v-model="location.maker" />
                      </b-form-group>
                    </div>
                    <div class="col-lg-7">
                      <b-form-group v-if="location.maker" label="Maker Category" label-for="makerCategory" label-class="text-center">
                        <b-radio-group id="makerCategory" name="makerCategory" v-model="location.maker_category" style="column-count: 3" stacked>
                          <b-radio value="Artists & Craftspeople">Artists &amp; Craftspeople</b-radio>
                          <b-radio value="Craft Beer/Winery/Spirits">Craft Beer/Winery/Spirits</b-radio>
                          <b-radio value="Fashion">Fashion</b-radio>
                          <b-radio value="Food Producers">Food Producers</b-radio>
                          <b-radio value="Heavy Manufacturing">Heavy Manufacturing</b-radio>
                          <b-radio value="Literary">Literary</b-radio>
                          <b-radio value="Music">Music</b-radio>
                          <b-radio value="Retail">Retail</b-radio>
                        </b-radio-group>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab
                :disabled="
                  !location.name ||
                  !location.slug ||
                  !location.organization_id ||
                  !location.category ||
                  !location.address ||
                  !location.city ||
                  !this.location.counties.length > 0 ||
                  !location.summary ||
                  !location.description ||
                  location.experiences_ids < 1
                "
                class="tab-text"
              >
                <template slot="title">
                  <div class="tab-class">4</div>
                  <div v-if="location.category" :ref="location.category" class="tab-title type-class">
                    {{ location.category.replace(/([a-z])([A-Z])/g, `$1 $2`) }}
                  </div>
                  <div v-else class="tab-title">Type</div>
                </template>
                <div>
                  <h1>Location Category</h1>
                  <b-tabs>
                    <b-tab title="Accommodation" title-item-class="d-none" :active="location.category === 'accommodation'">
                      <div v-for="(accommodation, index) in location.accommodations" :key="index">
                        <accommodation v-model="location.accommodations[index]" :ref="`accommodation-${index}`" />
                      </div>
                    </b-tab>

                    <b-tab title="Attraction" title-item-class="d-none" :active="location.category === 'attraction'">
                      <div v-for="(attraction, index) in location.attractions" :key="index">
                        <attraction v-model="location.attractions[index]" :ref="`attraction-${index}`" />
                      </div>
                    </b-tab>

                    <b-tab title="Food & Beverage Service" title-item-class="d-none" :active="location.category === 'food'">
                      <div v-for="(food, index) in location.food" :key="index">
                        <food v-model="location.food[index]" :ref="`food-${index}`" :locationId="locationId" />
                      </div>
                    </b-tab>

                    <b-tab title="Retail" title-item-class="d-none" :active="location.category === 'retail'">
                      <div v-for="(retail, index) in location.retails" :key="index">
                        <retail v-model="location.retails[index]" />
                      </div>
                    </b-tab>

                    <b-tab title="Service" title-item-class="d-none" :active="location.category === 'service'">
                      <div v-for="(service, index) in location.services" :key="index">
                        <service v-model="location.services[index]" />
                      </div>
                    </b-tab>

                    <b-tab title="Shopping Destination" title-item-class="d-none" :active="location.category === 'shoppingDestination'">
                      <div v-for="(shop, index) in location.shoppingDestinations" :key="index">
                        <shoppingDestination v-model="location.shoppingDestinations[index]" />
                      </div>
                    </b-tab>

                    <b-tab title="Venue" title-item-class="d-none" :active="location.category === 'venue'">
                      <div v-for="(venue, index) in location.venues" :key="index">
                        <venue v-model="location.venues[index]" />
                      </div>
                    </b-tab>
                    <b-tab title="Information Source" title-item-class="d-none" :active="location.category === 'informationSource'">
                      <div v-for="(informationSource, index) in location.informationSources" :key="index">
                        <informationSource v-model="location.informationSources[index]" />
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </b-tab>
              <b-tab
                :disabled="
                  !location.name ||
                  !location.slug ||
                  !location.organization_id ||
                  !location.category ||
                  !location.address ||
                  !location.city ||
                  !this.location.counties.length > 0 ||
                  !location.summary ||
                  !location.description ||
                  !location.experiences_ids ||
                  veeErrors.items.length > 0
                "
                class="tab-text nav-justified"
              >
                <template slot="title" class="nav-justified">
                  <div class="tab-class">5</div>
                  <div class="tab-title">
                    Media &amp; Social
                    <div class="optional media-tab">Optional</div>
                  </div>
                </template>
                <div class="row">
                  <div class="col-lg-6">
                    <h1>Social Networks</h1>
                    <div class="row">
                      <div class="col-lg-12">
                        <b-form-group v-if="$store.state.misc.social_networks">
                          <div v-for="network in $store.state.misc.social_networks" :key="network.name">
                            <b-input-group :prepend="network.base_url" class="mt-3">
                              <b-form-input
                                v-if="location.networks && location.networks[network.name]"
                                v-model="location.networks[network.name].account_name"
                                @input="dirty = true"
                                data-networkname="network.name"
                                :data-networkid="network._id"
                                ref="eventNetwork"
                              ></b-form-input>
                              <b-form-input v-else @input="dirty = true" :data-networkid="network._id" :data-networkname="network.name" ref="eventNetwork"></b-form-input>
                            </b-input-group>
                          </div>
                        </b-form-group>
                      </div>
                    </div>
                    <h1>Images</h1>
                    <div class="image-message">
                      The more images you have the better. You should have a minimum of one image that will be shown at the top of the page known as the
                      <span class="bold-text">featured image</span>. We would prefer you to have at least 5 or 6 images. If adding multiple images, you must check one of the images
                      as <span class="bold-text">featured.</span> Only jpg, jpeg, gif, and png are accepted at this time.
                    </div>
                  </div>
                </div>
                <!-- Images Component -->
                <div>
                  <photos :files="location.photos" :type="location._type" v-on:updateFiles="updatePhotos" v-on:featuredImageChanged="checkShowFeaturedImageNotification"
                    ref="photoUpload" />
                </div>
                <div v-if="showFeaturedImageNotification" class="mb-4 featured-image-notification">
                  You have removed your featured image. Please select another image from the other photos here to be your new featured image.
                  This image will be the first image users see when they land on your listing and will also be featured along with other listings in feature cells across the site.
                  If you do not select one then we will automatically assign one.
                </div>

                <h1>Videos</h1>
                <div class="row">
                  <div class="col-lg-6">
                    <b-form-group label="Youtube URL" label-for="video" class="">
                      <div class="image-desc">
                        Currently we only support Youtube videos. Please enter the entire URL from Youtube from the share link. It will look something like
                        https://youtu.be/abcdE1FGhij and you may only have one video at a time.
                      </div>
                      <b-form-input id="video" name="video" v-model="location.video" />
                    </b-form-group>
                  </div>

                  <div class="col-lg-6">
                    <b-form-group label="Video Description/Credit" label-for="video_description" class="">
                      <div class="image-desc mt-3 mb-3">The "Description" is a 150 word paragraph that describes the video or gives credit to the creators.</div>
                      <b-form-input id="video_description" name="video_description" v-model="location.video_description" />
                    </b-form-group>
                  </div>
                </div>
              </b-tab>
              <b-tab
                :disabled="
                  !location.name ||
                  !location.slug ||
                  !location.organization_id ||
                  !location.category ||
                  !location.address ||
                  !location.city ||
                  !this.location.counties.length > 0 ||
                  !location.summary ||
                  !location.description ||
                  location.experiences_ids < 1 ||
                  veeErrors.items.length > 0
                "
                class="tab-text"
              >
                <template slot="title">
                  <div class="tab-class">6</div>
                  <div class="tab-title">
                    Activities
                    <div class="optional">Optional</div>
                  </div>
                </template>
                <div class="row">
                  <div class="col-lg-6">
                    <h1>Activities</h1>
                    <div>
                      An activity is something your location offers within your day-to-day operations. Examples could be tours, camps, special programs, equipment rentals, etc.
                    </div>
                    <div>
                      <b-button value="false" class="btn btn-secondary mt-3" @click="createNewActivity()">New Activity</b-button>
                    </div>
                    <div>
                      <b-form-group label="Activity Name" label-for="activity_name" class="mt-5">
                        <b-form-input
                          :disabled="this.createActivity === false && !this.edit"
                          id="activity_name"
                          name="activity_name"
                          :placeholder="placeholder"
                          v-model="newActivity.name"
                        />
                        <div>The name of the specific activity your location offers.</div>
                      </b-form-group>
                      <b-form-group label="Starting Price" label-for="rate" class="mt-5">
                        <b-input-group>
                          <template #prepend v-if="newActivity.rate.toUpperCase() !== 'FREE'">
                            <b-input-group-text>From $</b-input-group-text>
                          </template>
                          <b-form-input :disabled="this.createActivity === false && !this.edit" id="rate" name="rate" v-model="newActivity.rate" />
                        </b-input-group>
                        <div>The lowest price to participate in this activity. If it is a free activity, simply type FREE.</div>
                      </b-form-group>
                      <b-form-group label="Description" label-for="description" class="text-left contentField">
                        <b-form-textarea :disabled="this.createActivity === false && !this.edit" id="description" name="description" v-model="newActivity.description" />
                        <div>The description of the specific activity your location offers. Typically a sentence or two.</div>
                      </b-form-group>
                      <b-form-group label="Frequency" label-for="frequency">
                        <b-form-select :disabled="this.createActivity === false && !this.edit" id="frequency" name="frequency" v-model="newActivity.frequency">
                          <option value="Daily">Daily</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Weekend">Weekend</option>
                          <option value="Monthly">Monthly</option>
                          <option value="Check Website">Check Website</option>
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="activities-title mt-5">My Current Activities</div>
                    <div v-for="(act, index) in location.activities" :key="index" class="activity mt-3">
                      <div class="row">
                        <div @click="activitySelected(index)" class="edit-name">
                          {{ act.name }}
                        </div>
                        <div @click="activitySelected(index)" class="edit-icons mr-5">
                          <font-awesome-icon icon="pen" />
                        </div>
                        <div @click="activityDeleted(index)" class="edit-icons">X</div>
                      </div>
                    </div>
                    <div class="activities-title mt-5">Example Appearance</div>
                    <div class="example-card">
                      <div class="example-title">{{ newActivity.name }}</div>
                      <div class="example-subtext">
                        {{ newActivity.frequency }}
                        <span v-if="newActivity.rate || newActivity.frequency"> | </span>
                        <span v-if="newActivity.rate.toUpperCase() !== 'FREE' && !!newActivity.rate">From $ </span>{{ newActivity.rate }}
                      </div>
                      <div v-html="newActivity.description" class="example-desc"></div>
                    </div>
                  </div>
                  <div class="ml-15">
                    <b-button v-if="!this.edit && this.createActivity" :disabled="!this.createActivity" class="btn btn-secondary mt-3" @click="addActivity()">Add</b-button>
                    <b-button v-else :disabled="!this.edit && !this.createActivity" class="btn btn-secondary mt-3" @click="addActivity()">Update</b-button>
                    <b-button id="cancelActivityBtn" class="btn-white ml-3 mt-3" @click="cancelActivity()">Cancel</b-button>
                  </div>
                </div>
              </b-tab>
            </div>
          </b-tabs>
        </b-form>
      </b-card>
    </div>
    <div class="footer-bar">
      <b-button v-if="this.locationId" @click="$router.push({ name: 'locations detail' })" class="mr-5 btn-white cancel-btn ml-50">Cancel Changes</b-button>
      <b-button v-else @click="$router.push('/locations')" class="ml-2 btn-white ml-50 cancel-btn">Cancel Changes</b-button>
      <b-button
        v-if="tabIndex === 0"
        @click="
          nextTab();
          tabIndex++;
        "
        :disabled="!location.name || !location.slug || !location.organization_id || !location.category"
        class="save-btn"
        >Next</b-button
      >
      <b-button
        v-else-if="tabIndex === 1"
        @click="
          nextTab();
          tabIndex++;
        "
        :disabled="!location.address || !location.city || this.location.counties.length === 0 || !location.zip"
        class="save-btn"
        >Next</b-button
      >
      <b-button
        v-else-if="tabIndex === 2"
        @click="
          nextTab();
          tabIndex++;
        "
        :disabled="!location.summary || !location.description || location.experiences_ids < 1"
        class="save-btn"
        >Next</b-button
      >
      <b-button
        v-else-if="tabIndex === 3"
        @click="
          nextTab();
          tabIndex++;
        "
        :disabled="veeErrors.items.length > 0"
        class="save-btn"
        >Next</b-button
      >
      <b-button
        v-else-if="tabIndex !== 5"
        @click="
          nextTab();
          tabIndex++;
        "
        class="save-btn"
        >Next</b-button
      >
      <template v-else>
        <b-button v-if="!isLoading" :disabled="veeErrors.any()" @click="saveLocation()" class="save-btn">Save Location</b-button>
        <b-button v-if="isLoading" class="save-btn disabled">Submitting...</b-button>
      </template>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { required } from 'vuelidate/lib/validators';
import TelephoneInput from '@/components/TelephoneInput.vue';
import photos from '../../components/Photos.vue';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';
import accommodation from './components/accommodation.vue';
import attraction from './components/attraction.vue';
import food from './components/food.vue';
import informationSource from './components/informationSource.vue';
import retail from './components/retail.vue';
import service from './components/service.vue';
import shoppingDestination from './components/shoppingDestination.vue';
import venue from './components/venue.vue';

export default {
  components: {
    photos,
    accommodation,
    attraction,
    venue,
    retail,
    food,
    shoppingDestination,
    informationSource,
    service,
    Loading,
    BreadcrumbsHelper,
    TelephoneInput,
  },
  data() {
    return {
      isLoading: false,
      submitted: false,
      submitTest: false,
      edit: false,
      createActivity: false,
      disabled: true,
      showFeaturedImageNotification: false,
      form: {},
      tabIndex: 0,
      activityIndex: '',
      newActivity: {
        name: '',
        rate: '',
        frequency: '',
        description: '',
      },
      nameIndex: 1,
      Breadcrumbs: [
        {
          text: 'Partners',
          active: true,
        },
        {
          text: 'Locations',
          href: '/locations',
        },
        {
          text: 'New Location',
          active: true,
        },
      ],
      urlTest: /(http(s?)):\/\//i,
      userOrgs: [],
      socialNetworks: this.$store.state.misc.social_networks,
      location: {
        googlePlaceId: '',
        googlePlaceName: '',
        category: '',
        name: '',
        nameNoPlace: '',
        slug: '',
        directions: '',
        precautions: '',
        organization: '',
        publish: 'None',
        telephone: '',
        address: '',
        city: '',
        zip: '',
        counties: [],
        wheelchair: true,
        website: '',
        coords: { lat: null, lng: null },
        summary: '',
        description: '',
        experiences: [],
        badges: [],
        networks: [],
        activities: [],
        informationSources: [],
        accommodations: [],
        attractions: [],
        venues: [],
        retails: [],
        services: [],
        food: [],
        photos: [],
        shoppingDestinations: [],
        video: '',
        video_description: '',
        experiences_ids: [],
        social_networks: {},
        social_networks_to_save: [],
        discounts: [],
        _type: '',
        pets_allowed: false,
        children_allowed: false,
        general_amenities: [],
        water_amenities: [],
        facilities: false,
        hours_of_operation: '',
        maker: false,
        maker_category: '',
        recreational_amenities: [],
      },
      accommodationTypes: ['BedAndBreakfast', 'Campground', 'HotelOrMotel', 'SportsmanLodgeOrCabin', 'VacationRental'],
      attractionTypes: [
        'AmusementPark',
        'BotanicalGardens',
        'GolfCourse',
        'HistoricSite',
        'IndoorRecreationSite',
        'IndustryManufacturing',
        'Museum',
        'NationalPark',
        'OtherPark',
        'OutdoorRecreationSite',
        'ScienceCenter',
        'SportsFacility',
        'StatePark',
        'ZoologicalPark',
      ],
      foodTypes: [
        'Restaurant',
        'Bakery',
        'BarLoungeNightclubOrTavern',
        'BreweryOrDistillery',
        'CoffeeShopOrTeaRoom',
        'DelicatessenLunchCounterOrSodaFountain',
        'IceCreamOrDessertShop',
        'FoodTruck',
      ],
      retailTypes: ['AntiquesAndCollectibles', 'ArtGallery', 'Bookstore', 'Boutique', 'HomeAndGarden', 'Outdoor', 'Secondhand', 'SpecialtyFoodAndBeverage'],
      serviceTypes: ['BoatCharter', 'GuidesToursOrRides', 'OutfitterOrEquipmentRental', 'Spa'],
      shoppingDestinationTypes: ['FarmersMarket', 'FleaMarket', 'OutletMall', 'ShoppingCenter', 'ShoppingDistrict', 'ShoppingMall'],
      venueTypes: ['Amphitheater', 'Arena', 'Cinema', 'ConcertHall', 'ConferenceCenter', 'ExhibitionHall', 'FairGrounds', 'MusicHall', 'Racetrack', 'Stadium', 'Theater'],
      informationSourceTypes: ['DMO', 'Organization', 'VisitorCenter', 'Not Provided'],
      map: {
        zoom: 6,
        center: {
          lat: 33,
          lng: -86.8104,
        },
      },
      organizations: [],
      badgeOptions: [],
      config: {
        key: `${process.env.VUE_APP_FROALA}`,
        heightMax: 150,
        toolbarButtons: ['bold', 'italic', 'underline', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'insertLink', '|', 'html', '|', 'undo', 'redo'],
        events: {},
      },
      customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], ['code-block']],
    };
  },
  props: {
    locationId: {
      type: String,
    },
  },
  validations: {
    location: {
      name: {
        required,
      },
      organization_id: {
        required,
      },
      city: {
        required,
      },
      address: {
        required,
      },
      counties: {
        required,
      },
      summary: {
        required,
      },
      description: {
        required,
      },
      coords: {
        lat: {
          required,
        },
      },
      _type: {
        required,
      },
    },
  },
  async created() {
    await Promise.all([this.getBadges(), this.getSocialNetworks(), this.getLocationDetails(), this.getOrganizations()]);
  },
  computed: {
    placeholder() {
      return this.createActivity === true ? 'New Activity' : '';
    },
  },
  methods: {
    async getSocialNetworks() {
      if (this.$store.state.misc.social_networks && this.$store.state.misc.social_networks.length === 0) {
        await this.$store.dispatch('misc/getSocialNetworks');
      }
    },
    checkShowFeaturedImageNotification(updatedPhotos) {
      this.showFeaturedImageNotification = false;

      if (updatedPhotos.length > 0 && !updatedPhotos.some(x => x.featured)) {
        this.showFeaturedImageNotification = true;
      }
    },
    async getBadges() {
      if (this.$store.state.misc.badges && this.$store.state.misc.badges.length === 0) {
        await this.$store.dispatch('misc/getBadges');
      }
      this.badgeOptions = this.$store.state.misc.badges.map((b) => ({
        text: b.name,
        value: b._id,
        imageUrl: `https://alabama-travel.s3.amazonaws.com/partners-uploads/badge/image/${b._id}/${b.image}`,
      }));
    },
    async getOrganizations() {
      const isPartner = this.$store.state.auth.user.role === 'partner' || this.$store.state.auth.user.role === 'dmo' || this.$store.state.auth.user.role === 'user';
      const response = await axios.get(`${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/${isPartner ? `getOrgsForUser/${this.$store.state.auth.mUser._id}` : 'organizations/lean'}`);
      const orgs = isPartner ? response.data.userOrganizations : response.data.organizations;
      this.userOrgs = orgs.map((o) => ({ text: o.name, value: o._id }));
    },
    async getLocationDetails() {
      if (this.locationId) {
        const locationResponse = await axios.get(`${process.env.VUE_APP_API_LOCATIONS_ROOT}/${this.locationId}`);
        const social = {};
        if (locationResponse.data.location.social_networks) {
          for (let i = 0; i < locationResponse.data.location.social_networks.length; i++) {
            social[locationResponse.data.location.social_networks[i].network_name] = locationResponse.data.location.social_networks[i];
          }
        }
        const existing = locationResponse.data.location;
        this.location = {
          _type: existing._type ? existing._type : (existing._type = 'Not Provided'),
          name: existing.name,
          slug: existing.slug,
          organization_id: existing.organization_id,
          organization: existing.organization,
          publish: existing.publish,
          address: existing.address,
          city: existing.city,
          zip: existing.zip,
          counties: existing.counties,
          wheelchair: existing.wheelchair_accessible,
          activities: existing.activities ? existing.activities : [],
          directions: existing.directions,
          precautions: existing.precautions,
          website: existing.website,
          coords: {
            lat: parseFloat(existing.latitude, 10),
            lng: parseFloat(existing.longitude, 10),
          },
          summary: existing.summary,
          description: existing.description,
          badges: existing.badge_ids,
          networks: social,
          social_networks: existing.social_networks,
          informationSources: existing.informationSources ? existing.informationSources : [],
          accommodations: existing.accommodations ? existing.accommodations : [],
          attractions: existing.attractions ? existing.attractions : [],
          venues: existing.venues ? existing.venues : [],
          retails: existing.retails ? existing.retails : [],
          services: existing.services ? existing.services : [],
          shoppingDestinations: existing.shopingDestinations ? existing.shopingDestinations : [],
          food: existing.food_service ? existing.food_service : [],
          photos: existing.photos,
          video: existing.video,
          video_description: existing.video_credit,
          rates: existing.rates,
          telephone: existing.telephone || '',
          reservations_url: existing.reservations_url,
          pets_allowed: existing.pets_allowed,
          children_allowed: existing.children_allowed,
          general_amenities: existing.general_amenities,
          credit_cards: existing.credit_cards,
          water_amenities: existing.water_amenities,
          cost: existing.cost === 'Admission Charged',
          fees: existing.fees,
          discounts: existing.discounts,
          menu_url: existing.menu_url,
          tickets_url: existing.tickets_url,
          schedule_url: existing.schedule_url,
          googlePlaceName: existing.googlePlaceName,
          reservations_phone: existing.reservations_phone,
          capacity: existing.capacity,
          facilities_capacity: existing.facilities_capacity,
          facilities: existing.facilities,
          hours_of_operation: existing.hours_of_operation,
          maker: existing.maker,
          maker_category: existing.maker_category,
          recreation_amenities: existing.recreation_amenities,
          experiences_ids: existing.experience_types ? existing.experience_types : [],
        };
        this.location.category = this.setLocationCategory(this.location._type);
        this.setLocationDetails(this.location._type);

        this.Breadcrumbs[2].text = `${this.location.name}`;
      }
    },
    updateActivity() {
      this.activity_name = '';
    },
    async saveLocation() {
      try {
        this.submitTest = true;
        this.isLoading = true;
        this.submitted = true;

        let valid = true;
        if (this.location.accommodations.length > 0) {
          this.compileAccommodation();
          valid = this.$refs['accommodation-0'][0].validate();
        }

        if (typeof this.location.facilities === 'object') {
          this.location.facilities = false;
        }

        if (typeof this.location.pets_allowed === 'object') {
          this.location.pets_allowed = false;
        }

        if (typeof this.location.children_allowed === 'object') {
          this.location.children_allowed = false;
        }

        if (this.location.attractions.length > 0) {
          this.compileAttraction();
          valid = this.$refs['attraction-0'][0].validate();
        }

        if (this.location.food.length > 0) {
          this.compileFood();
          valid = this.$refs['food-0'][0].validate();
        }

        if (this.location.retails.length > 0) {
          this.compileRetail();
        }

        if (this.location.services.length > 0) {
          this.compileService();
        }

        if (this.location.shoppingDestinations.length > 0) {
          this.compileShoppingDestination();
        }

        if (this.location.venues.length > 0) {
          this.compileVenue();
        }

        if (this.location.informationSources.length > 0) {
          this.compileInformationSource();
        }

        this.compileSocialNetworks();

        this.$v.$touch();

        if (!valid || this.$v.$invalid || this.location.experiences_ids.length < 1) {
          const message = 'Missing Required Fields';
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 8000,
            appendToast: true,
          });
          this.isLoading = false;

          return;
        }
        const regEx = /(http(s?)):\/\//i;
        if (this.location.website && !regEx.test(this.location.website)) {
          const message = 'Website URL must include http:// or https://';
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 8000,
            appendToast: true,
          });
          this.isLoading = false;

          return;
        }
        if (this.location.reservations_url && !regEx.test(this.location.reservations_url)) {
          const message = 'Reservation URL must include http:// or https://';
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 8000,
            appendToast: true,
          });
          this.isLoading = false;

          return;
        }
        if (this.location.menu_url && !regEx.test(this.location.menu_url)) {
          const message = 'Menu URL must include http:// or https://';
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 8000,
            appendToast: true,
          });
          this.isLoading = false;
          return;
        }
        if (this.location.tickets_url && !regEx.test(this.location.tickets_url)) {
          const message = 'Ticket URL must include http:// or https://';
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 8000,
            appendToast: true,
          });
          this.isLoading = false;
          return;
        }
        await this.$refs.photoUpload.uploadFiles();

        await this.sendLocationToServer();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
    async sendLocationToServer() {
      const url = this.locationId ? `${process.env.VUE_APP_API_LOCATIONS_ROOT}/${this.locationId}` : `${process.env.VUE_APP_API_LOCATIONS_ROOT}/`;
      try {
        this.isLoading = true;
        const response = await axios.post(url, this.location);
        if (response.data.success) {
          this.dirty = false;
          this.version = response.data;
          const self = this;
          if (this.locationId || this.$store.state.auth.user.role === 'admin' || this.$store.state.auth.user.role === 'editor') {
            this.$router.push(
              {
                name: 'locations detail',
                params: { locationId: response.data.locationId },
              },
              () => {
                setTimeout(() => {
                  self.$bvToast.toast(`${JSON.stringify(response.data.message)}`, { title: 'Success', autoHideDelay: 5000, appendToast: true });
                }, 500);
              },
            );
          } else {
            this.$router.push({ name: 'locations list' }, () => {
              setTimeout(() => {
                self.$bvToast.toast(`${JSON.stringify(response.data.message)}`, { title: 'Success', autoHideDelay: 5000, appendToast: true });
              }, 500);
            });
          }
        } else {
          this.$bvToast.toast(`${JSON.stringify(response.data.message)}`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
          this.isLoading = false;
        }
      } catch (err) {
        this.$bvToast.toast('Something went wrong.', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
        this.isLoading = false;
      }
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    activitySelected(index) {
      this.edit = true;
      this.activityIndex = index;
      this.newActivity = {
        name: this.location.activities[index].name,
        rate: this.location.activities[index].rate,
        frequency: this.location.activities[index].frequency,
        description: this.location.activities[index].description,
      };
    },
    activityDeleted(index) {
      this.location.activities.splice(index, 1);
    },
    nextTab() {
      window.scrollTo(0, 0);
    },
    createNewActivity() {
      const newActivity = {
        name: '',
        rate: '',
        frequency: '',
        description: '',
      };
      this.newActivity = newActivity;
      this.edit = false;
      this.createActivity = true;
    },
    addActivity() {
      if (this.edit) {
        let currentActivity = this.location.activities[this.activityIndex];
        currentActivity = {
          name: this.newActivity.name,
          rate: this.newActivity.rate,
          frequency: this.newActivity.frequency,
          description: this.newActivity.description,
        };
        this.location.activities[this.activityIndex] = currentActivity;
        const newActivity = {
          name: '',
          rate: '',
          frequency: '',
          description: '',
        };
        this.newActivity = newActivity;
        this.edit = false;
      } else {
        this.location.activities.push(this.newActivity);
        const newActivity = {
          name: '',
          rate: '',
          frequency: '',
          description: '',
        };
        this.newActivity = newActivity;
        this.createActivity = false;
      }
    },
    cancelActivity() {
      const newActivity = {
        name: '',
        rate: '',
        frequency: '',
        description: '',
      };
      this.newActivity = newActivity;
      this.createActivity = false;
      this.edit = false;
    },
    typeSelected(type) {
      switch (type) {
        case 'accommodation':
          this.location.category = 'accommodation';
          if (this.location.accommodations.length === 0) {
            this.location.accommodations.push({
              _type: null,
              discounts: [],
              creditCards: [],
              amenities: [],
              waterAmenities: [],
            });
            this.location.attractions = [];
            this.location.food = [];
            this.location.retails = [];
            this.location.shoppingDestinations = [];
            this.location.venues = [];
            this.location.services = [];
            this.location.informationSources = [];
          }
          break;
        case 'attraction':
          this.location.category = 'attraction';
          if (this.location.attractions.length === 0) {
            this.location.attractions.push({
              _type: null,
              discounts: [],
              creditCards: [],
            });
            this.location.accommodations = [];
            this.location.food = [];
            this.location.retails = [];
            this.location.shoppingDestinations = [];
            this.location.venues = [];
            this.location.services = [];
            this.location.informationSources = [];
          }
          break;
        case 'food':
          this.location.category = 'food';
          if (this.location.food.length === 0) {
            this.location.food.push({
              _type: null,
              discounts: [],
              creditCards: [],
            });
            this.location.accommodations = [];
            this.location.attractions = [];
            this.location.retails = [];
            this.location.shoppingDestinations = [];
            this.location.venues = [];
            this.location.services = [];
            this.location.informationSources = [];
          }
          break;
        case 'retail':
          this.location.category = 'retail';
          if (this.location.retails.length === 0) {
            this.location.retails.push({
              _type: null,
              discounts: [],
              creditCards: [],
            });
            this.location.accommodations = [];
            this.location.attractions = [];
            this.location.food = [];
            this.location.shoppingDestinations = [];
            this.location.venues = [];
            this.location.services = [];
            this.location.informationSources = [];
          }
          break;
        case 'service':
          this.location.category = 'service';
          if (this.location.services.length === 0) {
            this.location.services.push({
              _type: null,
              discounts: [],
              creditCards: [],
            });
            this.location.accommodations = [];
            this.location.attractions = [];
            this.location.retails = [];
            this.location.food = [];
            this.location.shoppingDestinations = [];
            this.location.venues = [];
            this.location.informationSources = [];
          }
          break;
        case 'shoppingDestination':
          this.location.category = 'shoppingDestination';
          if (this.location.shoppingDestinations.length === 0) {
            this.location.shoppingDestinations.push({
              _type: null,
              discounts: [],
              creditCards: [],
            });
            this.location.accommodations = [];
            this.location.attractions = [];
            this.location.food = [];
            this.location.retails = [];
            this.location.venues = [];
            this.location.services = [];
            this.location.informationSources = [];
          }
          break;
        case 'venue':
          this.location.category = 'venue';
          if (this.location.venues.length === 0) {
            this.location.venues.push({
              _type: null,
              discounts: [],
              creditCards: [],
            });
            this.location.accommodations = [];
            this.location.attractions = [];
            this.location.food = [];
            this.location.retails = [];
            this.location.shoppingDestinations = [];
            this.location.services = [];
            this.location.informationSources = [];
          }
          break;
        case 'informationSource':
          this.location.category = 'informationSource';
          if (this.location.informationSources.length === 0) {
            this.location.informationSources.push({
              _type: null,
              discounts: [],
              creditCards: [],
            });
            this.location.accommodations = [];
            this.location.attractions = [];
            this.location.food = [];
            this.location.retails = [];
            this.location.shoppingDestinations = [];
            this.location.venues = [];
            this.location.services = [];
          }
          break;
        default:
          break;
      }
    },
    setLocationCategory(type) {
      if (this.attractionTypes.find((name) => name === type)) {
        return 'attraction';
      }
      if (this.accommodationTypes.find((name) => name === type)) {
        return 'accommodation';
      }
      if (this.foodTypes.find((name) => name === type)) {
        return 'food';
      }
      if (this.retailTypes.find((name) => name === type)) {
        return 'retail';
      }
      if (this.serviceTypes.find((name) => name === type)) {
        return 'service';
      }
      if (this.shoppingDestinationTypes.find((name) => name === type)) {
        return 'shoppingDestination';
      }
      if (this.venueTypes.find((name) => name === type)) {
        return 'venue';
      }
      if (this.informationSourceTypes.find((name) => name === type)) {
        return 'informationSource';
      }
      return '';
    },
    setPlace(place) {
      this.location.googlePlaceName = place.name;
      this.location.googlePlaceId = place.place_id;
      this.location.coords = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.map.center = this.location.coords;
      this.map.zoom = 13;

      let streetNumber = place.address_components.find((a) => a.types.includes('street_number'));
      streetNumber = streetNumber ? streetNumber.long_name : '';
      let streetName = place.address_components.find((a) => a.types.includes('route'));
      streetName = streetName ? streetName.long_name : '';
      if (streetName === '' && streetNumber === '') {
        this.location.address = '';
      } else {
        this.location.address = `${streetNumber} ${streetName}`;
      }
      let city = place.address_components.find((a) => a.types.includes('locality'));
      city = city ? city.long_name : '';
      this.location.city = city;

      let postal = place.address_components.find((a) => a.types.includes('postal_code'));
      postal = postal ? postal.long_name : '';
      this.location.zip = postal;
    },
    updatePhotos(photoFiles) {
      this.location.photos = photoFiles;
    },
    async generateSlug() {
      if (!this.locationId && this.location.name !== '') {
        const response = await axios.post(`${process.env.VUE_APP_API_LOCATIONS_ROOT}/generateSlug`, { name: this.location.name });
        this.location.slug = response.data;
      }
    },
    setLocationDetails(type) {
      this.location._type = type;
      switch (this.location.category) {
        case 'accommodation':
          this.location.accommodations.push(this.populateaccommodation(type));
          break;
        case 'attraction':
          this.location.attractions.push(this.populateAttraction(type));
          break;
        case 'food':
          this.location.food.push(this.populateFood(type));
          break;
        case 'retail':
          this.location.retails.push(this.populateRetail(type));
          break;
        case 'service':
          this.location.services.push(this.populateService(type));
          break;
        case 'shoppingDestination':
          this.location.shoppingDestinations.push(this.populateShoppingDestination(type));
          break;
        case 'venue':
          this.location.venues.push(this.populateVenue(type));
          break;
        case 'informationSource':
          this.location.informationSources.push(this.populateInformationSource(type));
          break;
        default:
          break;
      }
    },
    compileAccommodation() {
      this.location.category = 'accommodation';
      const singleaccommodation = this.location.accommodations[0];
      this.location._type = singleaccommodation._type;
      this.location.telephone = singleaccommodation.telephone;
      this.location.reservations_url = singleaccommodation.reservationsUrl;
      this.location.reservations_phone = singleaccommodation.phone;
      this.location.rates = singleaccommodation.rates;
      this.location.pets_allowed = singleaccommodation.petsAllowed;
      this.location.children_allowed = singleaccommodation.childrenAllowed;
      this.location.discounts = singleaccommodation.discounts;
      this.location.general_amenities = singleaccommodation.amenities;
      this.location.water_amenities = singleaccommodation.waterAmenities;
      this.location.credit_cards = singleaccommodation.creditCards;
      this.location.facilities = singleaccommodation.meetingFacilities;
      this.location.facilities_capacity = singleaccommodation.meetingCapacity;
      this.location.capacity = singleaccommodation.capacity;
      this.location.hours_of_operation = singleaccommodation.hoursOfOperation;
      this.location.recreation_amenities = singleaccommodation.recreationAmenities;
    },
    populateaccommodation(type) {
      return {
        _type: type,
        rates: this.location.rates,
        reservationsUrl: this.location.reservations_url,
        petsAllowed: this.location.pets_allowed,
        childrenAllowed: this.location.children_allowed,
        amenities: this.location.general_amenities ? this.location.general_amenities : [],
        creditCards: this.location.credit_cards ? this.location.credit_cards : [],
        waterAmenities: this.location.water_amenities ? this.location.water_amenities : [],
        discounts: this.location.discounts,
        phone: this.location.reservations_phone,
        meetingFacilities: this.location.facilities,
        meetingCapacity: this.location.facilities_capacity,
        capacity: this.location.capacity,
        hoursOfOperation: this.location.hours_of_operation,
        recreationAmenities: this.location.recreation_amenities ? this.location.recreation_amenities : [],
      };
    },
    compileAttraction() {
      this.location.category = 'attraction';
      const singleAttraction = this.location.attractions[0];
      this.location._type = singleAttraction._type;
      this.location.fees = singleAttraction.fees;
      this.location.telephone = singleAttraction.phone;
      this.location.cost = singleAttraction.cost ? 'Admission Charged' : 'Free';
      this.location.discounts = singleAttraction.discounts;
      this.location.credit_cards = singleAttraction.creditCards;
      this.location.hours_of_operation = singleAttraction.hoursOfOperation;
      if (this.location.cost === 'Free') {
        this.location.fees = '';
        this.location.discounts = [];
        this.location.credit_cards = [];
      }
    },
    populateAttraction(type) {
      return {
        _type: type,
        phone: this.location.telephone,
        cost: this.location.cost,
        fees: this.location.fees,
        discounts: this.location.discounts ? this.location.discounts : [],
        creditCards: this.location.credit_cards ? this.location.credit_cards : [],
        hoursOfOperation: this.location.hours_of_operation,
      };
    },
    compileFood() {
      this.location.category = 'food';
      const singleFood = this.location.food[0];
      this.location._type = singleFood._type;
      this.location.telephone = singleFood.phone;
      this.location.discounts = singleFood.discounts;
      this.location.menu_url = singleFood.menu;
      this.location.hours_of_operation = singleFood.hoursOfOperation;
      this.location.credit_cards = singleFood.creditCards;
    },
    populateFood(type) {
      return {
        _type: type,
        menu: this.location.menu_url,
        phone: this.location.telephone,
        discounts: this.location.discounts ? this.location.discounts : [],
        creditCards: this.location.credit_cards ? this.location.credit_cards : [],
        hoursOfOperation: this.location.hours_of_operation,
      };
    },
    compileRetail() {
      this.location.category = 'retail';
      const singleRetail = this.location.retails[0];
      this.location._type = singleRetail._type;
      this.location.telephone = singleRetail.phone;
      this.location.discounts = singleRetail.discounts;
      this.location.hours_of_operation = singleRetail.hoursOfOperation;
      this.location.credit_cards = singleRetail.creditCards;
    },
    populateRetail(type) {
      return {
        _type: type,
        phone: this.location.telephone,
        discounts: this.location.discounts ? this.location.discounts : [],
        hoursOfOperation: this.location.hours_of_operation,
        creditCards: this.location.credit_cards ? this.location.credit_cards : [],
      };
    },
    compileShoppingDestination() {
      this.location.category = 'shoppingDestination';
      const singleShoppingDestination = this.location.shoppingDestinations[0];
      this.location._type = singleShoppingDestination._type;
      this.location.telephone = singleShoppingDestination.phone;
      this.location.discounts = singleShoppingDestination.discounts;
      this.location.hours_of_operation = singleShoppingDestination.hoursOfOperation;
      this.location.credit_cards = singleShoppingDestination.creditCards;
    },
    populateShoppingDestination(type) {
      return {
        _type: type,
        phone: this.location.telephone,
        discounts: this.location.discounts ? this.location.discounts : [],
        hoursOfOperation: this.location.hours_of_operation,
        creditCards: this.location.credit_cards ? this.location.credit_cards : [],
      };
    },
    compileVenue() {
      this.location.category = 'venue';
      const singleVenue = this.location.venues[0];
      this.location._type = singleVenue._type;
      this.location.telephone = singleVenue.telephone;
      this.location.discounts = singleVenue.discounts;
      this.location.schedule_url = singleVenue.scheduleUrl;
      this.location.tickets_url = singleVenue.ticketUrl;
      this.location.credit_cards = singleVenue.creditCards;
      this.location.hours_of_operation = singleVenue.hoursOfOperation;
    },
    populateVenue(type) {
      return {
        _type: type,
        telephone: this.location.telephone,
        discounts: this.location.discounts ? this.location.discounts : [],
        scheduleUrl: this.location.schedule_url,
        ticketUrl: this.location.tickets_url,
        creditCards: this.location.credit_cards ? this.location.credit_cards : [],
        hoursOfOperation: this.location.hours_of_operation,
      };
    },
    compileSocialNetworks() {
      const locationNetworksRefs = this.$refs.eventNetwork;
      const locationNetworks = [];
      if (locationNetworksRefs) {
        locationNetworksRefs.forEach((net) => {
          const partnerSlug = net.localValue;
          const fixSlug = partnerSlug.lastIndexOf('/');
          const cleanSlug = partnerSlug.substring(fixSlug + 1);
          locationNetworks.push({
            social_network_id: net.$attrs['data-networkid'],
            account_name: cleanSlug,
            location_id: this.locationId,
          });
        });
      }
      this.location.social_networks_to_save = locationNetworks;
    },
    compileService() {
      this.location.category = 'service';
      const singleService = this.location.services[0];
      this.location._type = singleService._type;
      this.location.telephone = singleService.phone;
      this.location.discounts = singleService.discounts;
      this.location.hours_of_operation = singleService.hoursOfOperation;
      this.location.credit_cards = singleService.creditCards;
    },
    populateService(type) {
      return {
        _type: type,
        phone: this.location.telephone,
        discounts: this.location.discounts ? this.location.discounts : [],
        hoursOfOperation: this.location.hours_of_operation,
        creditCards: this.location.credit_cards ? this.location.credit_cards : [],
      };
    },
    compileInformationSource() {
      this.location.category = 'informationSource';
      const singleInformationSource = this.location.informationSources[0];
      this.location._type = singleInformationSource._type;
      this.location.telephone = singleInformationSource.phone;
      this.location.hours_of_operation = singleInformationSource.hoursOfOperation;
    },
    populateInformationSource(type) {
      return {
        _type: type,
        phone: this.location.telephone,
        hoursOfOperation: this.location.hours_of_operation,
      };
    },
  },
};
</script>

<style scoped>
.ml-50 {
  margin-left: 50px !important;
}

.featured-image-notification {
  border-radius: var(--rounded-lg);
  padding: 8px 24px 8px 24px;
  background-color: #E5F5FD;
}

.right {
  float: right;
}

.bold-text {
  font-weight: bold;
}

.container {
  padding-bottom: 200px;
}

.descriptions-section .form-group {
  width: 60%;
}

div.image-desc {
  font-size: 14px;
}

.form-group >>> div {
  font-size: 14px;
  color: #666666;
}

.availability-section >>> .custom-control-inline {
  width: 30%;
  margin-bottom: 10px;
}

.availability-section >>> .custom-control-inline:last-of-type {
  width: 50%;
}

.experiences-section >>> .btn-secondary {
  background-color: white;
  color: black;
  font-weight: 500;
  border: 1px solid #4e97b2;
  margin: 0px 20px 10px 0;
  min-width: 175px;
}

.experiences-section >>> .btn-group {
  display: inline;
}

.info-source,
.shopping-dest {
  display: inline-block;
  margin-right: 30px;
}

.image-message {
  font-size: 18px;
}

.ml-15 {
  margin-left: 15px;
}

.badges-section >>> .btn-secondary {
  background-color: white;
  color: black;
  border-radius: var(--rounded-xl);
  border-top-right-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
  font-weight: 500;
  margin: 0px 20px 10px 0;
  width: 175px;
  text-align: center;
  display: block;
  flex: 0;
}

.badges-section >>> .btn-secondary.active {
  background-color: white;
  border: 1px solid #4e97b2;
  color: black;
}

.badges-section >>> .btn-secondary:hover {
  border: 1px solid #4e97b2;
  -webkit-box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
  box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
}

.badge-wrap {
  display: flex;
  flex-wrap: wrap;
}

.badge-img {
  width: 140px;
  display: block;
  margin-left: 0%;
  margin-bottom: 10px;
}

.card {
  border: none;
}

.card-body h1 {
  margin: 0px 0 10px 0;
}

.experiences-section >>> .btn-secondary.active {
  background-color: #4e97b2;
  border: 1px solid #4e97b2;
  -webkit-box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
  box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
}

.tab-container {
  position: relative;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: white;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: var(--rounded);
}

.line {
  border: solid 1px var(--blue-500);
  height: 1px;
  right: 0;
  left: 0;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  width: 83%;
  top: 30px;
}

.tab-class {
  background: #cfe2e8;
  color: #1a3138;
  border-radius: 50%;
  height: 31px;
  width: 31px;
  display: flex;
  line-height: 31px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  border: solid 2px #1a3138;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  align-items: center;
}

.active .tab-class {
  background-color: #1a3138;
  color: #cfe2e8;
  border-radius: 50%;
  height: 31px;
  width: 31px;
  display: flex;
  line-height: 31px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
  align-items: center;
}

.tab-content {
  display: flex;
  justify-content: center;
  align-items: center;
}

.optional {
  color: gray;
  font-size: 12px;
  position: absolute;
  top: 60px;
  display: block;
  justify-content: center;
  align-items: center;
  margin-left: 14px;
}

.media-tab {
  margin-left: 35px;
}

.content {
  display: flex;
  justify-content: center;
}

.activities-title {
  font-size: 16px;
  font-weight: 500;
}

.activity {
  font-size: 14px;
  font-weight: 500;
  margin-left: 16px;
}

.activity:hover {
  text-decoration: underline;
}

.example-card {
  width: 430px;
  min-height: 290px;
  margin: 21px 33px 29px 0px;
  padding: 20px 16px 18px 13px;
  border-radius: var(--rounded-lg);
  box-shadow: 0 6px 6px -1px rgba(10, 22, 70, 0.1), 0 0 1px 0 rgba(10, 22, 70, 0.06);
  background-color: white;
}

.example-title {
  font-size: 20px;
  font-weight: 500;
  color: var(--blue-900);
}

.example-subtext {
  font-size: 14px;
  font-weight: 500;
  color: rgba(26, 49, 56, 0.6);
}

.example-desc {
  margin: 28px 0 0;
}

.save-options {
  position: absolute;
  right: 0px;
}

.hidden {
  display: none;
}

.tab-title {
  text-transform: capitalize;
}

.type-class {
  width: 170px;
}

div >>> .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: rgba(0, 0, 0, 0.125) !important;
  border-color: #dee2e6 #dee2e6 white;
}

div >>> .nav-item {
  margin: 0px 0px 0px 0px;
  line-height: 41px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

div >>> .card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-bottom: none;
  background: transparent;
}

div >>> .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #1a3138 !important;
  background: transparent;
  font-weight: 500;
  font-size: 18px;
}

div >>> .nav-link {
  padding: 0rem 0rem 0.5rem 0rem !important;
}

div >>> .nav-item > a {
  color: #1a3138 !important;
  background: transparent;
  font-weight: 500;
  font-size: 18px;
  justify-content: center;
  align-items: center;
}

div >>> .card {
  border: none;
  background: transparent;
}

div >>> .form-control {
  background: transparent;
}

.edit-icons {
  cursor: pointer;
  position: absolute;
  right: 0px;
}

.edit-name {
  cursor: pointer;
}

.red {
  color: #dc3545 !important;
  list-style-type: none;
}

.error-message {
  padding-left: 0px;
}

.footer-bar {
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  height: 84px;
  -webkit-box-shadow: 0 -1px 4px 0 rgb(0 0 0 / 50%);
  box-shadow: 0 -1px 4px 0 rgb(0 0 0 / 50%);
  background-color: white;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  z-index: 9999;
}

.cancel-btn {
  border: none;
  color: var(--blue-900);
  height: 40px;
  margin-right: 100px;
  width: 169px;
}

.save-btn {
  width: 169px;
  height: 40px;
  margin: 0 100px 0 0px;
  padding: 9px 11px;
  border-radius: var(--rounded);
  background-color: #1a3138;
}
</style>
